import { ExternalLink } from '@ui-components/actions/ExternalLink'
import { ModalVisualMode } from '@ui-components/containers/ModalTypes'
import { BodyText } from '@ui-components/typography/Typography'
import { IntlShape } from 'react-intl'
import * as R from 'remeda'

import { PrimaryButtonOptions, ShowModalOptions } from '../components/Modal'
import { EventHandler } from '../types'

interface ExternalLinkProps {
  href: string
  text: string
}

interface SecondParagraphProps {
  message: string
  externalLink?: ExternalLinkProps
}

export interface GetModalOptionsInput {
  header: string
  message: React.ReactNode
  mode?: ModalVisualMode
  buttonLabel: string
  onButtonClick?: () => void
  buttonType?: PrimaryButtonOptions['type']
  secondParagraph?: SecondParagraphProps
  requestId?: string
}

export const getModalOptions = ({
  header,
  message,
  mode = ModalVisualMode.Plain,
  buttonLabel,
  onButtonClick = R.doNothing(),
  buttonType,
  secondParagraph,
  requestId,
}: GetModalOptionsInput): ShowModalOptions => {
  const externalLink = secondParagraph?.externalLink
  return {
    header,
    children: (
      <div>
        <BodyText tagName="p">{message}</BodyText>
        {secondParagraph && (
          <BodyText tagName="p">
            {secondParagraph.message}
            {externalLink && <ExternalLink href={externalLink.href}>{externalLink.text}</ExternalLink>}
          </BodyText>
        )}
      </div>
    ),
    contentAriaLabel: header,
    primaryButtonOptions: {
      label: buttonLabel,
      onClick: onButtonClick,
      type: buttonType ?? 'secondary',
    },
    mode,
    requestId,
  }
}

export const getFailureModalOptions = (
  formatMessage: IntlShape['formatMessage'],
  onContinue: EventHandler = R.doNothing(),
  requestId?: string,
): ShowModalOptions => {
  return getModalOptions({
    header: formatMessage({ id: 'common-unexpected-technical-error' }),
    message: formatMessage({ id: 'common-error-technical-text' }),
    mode: ModalVisualMode.TechnicalError,
    buttonLabel: formatMessage({ id: 'common-ok' }),
    onButtonClick: onContinue,
    requestId,
  })
}
